<template>
  <div class="download-button">
    <vs-button
      class="download-button cursor-pointer"
      :color="AISEA_COLOR.BLUE"
      type="border"
      style="padding: 5px 14px;"
      @click="onClick"
    >
      <div class="flex justify-center items-center col-gap-2">
        <download-icon />
        <span class="download-text aisea-text-14-400-blue whitespace-no-wrap">{{
          text
        }}</span>
      </div>
    </vs-button>
  </div>
</template>

<script>
import ColorMixin from "@/mixins/ColorMixin.js";
import DownloadIcon from "@/views/enterprise/addon/operation/components/icons/DownloadIcon";
const EVENTS = {
  CLICK: "click",
};

export default {
  name: "OperationReportListDownloadButton",
  mixins: [ColorMixin],
  components: { DownloadIcon },
  props: {
    text: {
      type: String,
      default() {
        return this.$t("Views.Operation.Report.Download");
      },
    },
  },
  methods: {
    onClick() {
      this.$emit(EVENTS.CLICK);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";

.download-button {
  ::v-deep .download-button {
    width: 136px;
    height: 38px;
    border-radius: 4px;
    border: 1px solid $aisea-blue;

    .vs-button-backgroundx.vs-button--background {
      display: none; // ボタンクリックした時に、背景色が変わるのを防ぐ
    }
  }
}
</style>
